export const rank_first = require("./rank_first.png");
export const rank_two = require("./rank_two.png");
export const rank_three = require("./rank_three.png");
export const rank_list_btn_icon = require("./rank_list_btn_icon.png");
export const rank_list_title = require("./rank_list_title.png");